<template>
  <div class="content-video-detail-container content-bg" :class="{
    isMobile: isMobile()
  }">
    <div class="content-detail sys-max-width">
      <detailNav
        :title="detailInfo.title"
        :pid="String(moduleId)"
        :moduleName="moduleData.name"
      />

      <div class="content-detail-box lg-mx flex justify-between">
        <div class="left">
          <top
            :detailInfo="detailInfo"
          />

          <div class="content-text">
            <video v-if="detailInfo.url" :src="detailInfo.url" controls controlsList="nodownload" oncontextmenu="return(false)" class="video">
            </video>

            <div v-if="isShowVideoSet" class="warp-box">
              <el-button @click="videoSetDialog = true" type="primary">请录入观看视频人数</el-button>
            </div>
          </div>

          <div v-if="detailInfo.files && detailInfo.files.length > 0" class="down-list flex justify-end">
            <div class="down-item" @click="handleDown(detailInfo.files)">点击下载附件</div>
          </div>

          <div class="comment-box">
            <div class="submit-comment">
              <div class="title flex items-center">
                <div class="mr-3">发表评论</div>
                <div>
                  <el-rate 
                    :colors="colors" 
                    show-score 
                    text-color="#ff9900" 
                    v-model="scoreVal"
                    :score-template="showScore"
                  />
                </div>
              </div>

              <div class="input-box flex justify-between">
                <div class="ava overflow-hidden">
                  <img class="img-common" :src="avaUrl" alt="">
                </div>

                <div class="input">
                  <el-input
                    type="textarea"
                    :rows="6"
                    maxlength="500"
                    show-word-limit
                    v-model="commentVal">
                  </el-input>
                </div>
              </div>

              <div class="flex items-center justify-between">
                <!-- <div class="em">表情</div> -->
                <div></div>
                <el-button @click="addComment" size="small" type="primary">发表</el-button>
              </div>
            </div>

            <div class="comment-list">
              <div class="title">最新评论</div>

              <div class="list">
                <div :key="index" v-for="(item, index) in commentList" class="item flex items-start justify-between">
                  <div class="ava"><img class="img-common" :src="item.avatar" alt=""></div>

                  <div class="right-content">
                    <div class="flex items-center">
                      <div class="name">{{ item.user_name }}</div>
                      <div class="time">{{ item.comment_time }}</div>
                    </div>

                    <div class="content">{{ item.content }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!isMobile()" class="right">
          <div class="common-block">
            <div class="top flex items-center">
              <div class="icon news"></div>
              <div class="title">相关推荐</div>
            </div>

            <div class="list">
              <div @click="goDetail(item)" :key="index" v-for="(item, index) in videoRecommendList" class="item flex justify-between items-start">
                <div class="list-left">
                  <div class="icon"></div>
                </div>

                <div class="list-right">
                  <div class="content">{{ item.title }}</div>

                  <div class="time">{{ dayjs(item.create_time).format('YYYY-MM-DD') }}</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="objectCode" class="common-block">
            <div class="top flex items-center">
              <div class="icon qrcode el-icon-picture"></div>
              <div class="title">上传图片，请使用微信扫描下方二维码</div>
            </div>

            <div class="qrcode" id="qrcode"></div>
          </div>

          <div v-if="objectCode" class="common-block">
            <div class="top flex items-center">
              <div class="icon qrcode el-icon-picture"></div>
              <div class="title">填写问卷，请使用微信扫描下方二维码</div>
            </div>

            <div class="qrcode" id="question-qrcode"></div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="录入观看视频人数"
      :visible.sync="videoSetDialog"
      width="340px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center>
      <div class="flex justify-center items-center">
        <span>人数：</span>
        <el-input-number :precision="0" size="small" v-model="viewNumber" :min="1" :max="9999" label="描述文字"></el-input-number>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="videoSetDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitVideoSetHandle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
/* eslint-disable */
import dayjs from 'dayjs'
import QRCode from 'easyqrcodejs'
import { MODULE_CONFIG, appKey } from '@/config/index'
import { addComment, fetchCommentList } from '@/api/comment'
import { fetchVideoDetail, fetchRecommendVideoList, fetchVideoSetInfo, setVideoSet } from '@/api/video'
import { getAva, getToken, getMobile, getAccount, getState } from '@/utils/auth'
import { isMobile } from '@/utils/index'
import axios from 'axios'

import detailNav from './detailNav'
import top from './top'

export default {
  components: {
    detailNav,
    top
  },
  data() {
    const { id, video_code } = this.$route.query

    return {
      moduleId: MODULE_CONFIG.VIDEO,
      contentId: id,
      videoCode: video_code,

      objectCode: '',

      avaUrl: getAva(),

      detailInfo: {},

      commentList: [],
      commentVal: '',

      scoreVal: 0,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],

      videoRecommendList: [],

      videoSetDialog: false,
      isShowVideoSet: false,
      viewNumber: 1
    }
  },
  computed: {
    moduleData() {
      return this.$store.getters.getModuleItemById(this.moduleId)
    },

    showScore() {
      return !this.scoreVal ? '' : String(this.scoreVal * 2)
    }
  },

  watch: {
    $route(newVal) {
      const { id, video_code } = newVal.query

      this.contentId = id
      this.videoCode = video_code
      this.objectCode = ''
      this.getContentDetail()
    }
  },

  methods: {
    dayjs,
    isMobile,

    async handleDown(files) {
      if (files.length > 0) {

        const fileCode = files[0].file_code
        const fileName = files[0].original_name

        try {
          let res = await axios.get(`/api/v1/contents/pdf-info`, {
            params: {
              object_code: fileCode
            },
            headers: {
              token: getToken(),
              'app-key': appKey,
              timestamp: new Date().getTime()
            },
            responseType: 'blob',
          });
          const link = document.createElement('a');
          let blob = new Blob([res.data]);
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);

          link.download = fileName; //下载后文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.log(error)
        }
      }
    },

    goDetail(item) {
      this.$router.push({
        name: 'videoDetail',
        query: {
          id: item.id,
          video_code: item.video_code
        }
      })
    },

    async getContentDetail() {
      try {
        this.detailInfo = await fetchVideoDetail({
          id: this.contentId,
          object_code: this.videoCode
        })

        this.getVideoSetInfo()
        this.getCommentList()
      } catch (error) {
        console.log(error)
      }
    },

    async getVideoSetInfo() {
      try {
        // exist=1 不需要录入 exist=0 需要录入
        const { exist, object_code } = await fetchVideoSetInfo({
          "video_code": this.videoCode,
        })

        if (object_code) {
          this.objectCode = object_code
          this.$nextTick(() => {
            this.initQrCode() // 生成二维码
            this.initQuestionQrCode()
          })
        }
        
        this.isShowVideoSet = (exist === 0)
      } catch (error) {
        console.log(error)
      }
    },

    async submitVideoSetHandle() {
      if (!this.viewNumber) {
        this.$message.error('请先录入视频观看人数')
        return
      }

      try {
        const { object_code } =  await setVideoSet({
          "video_code": this.videoCode,
          "count": this.viewNumber
        })

        this.objectCode = object_code
        this.$nextTick(() => {
          this.initQrCode() // 生成二维码
          this.initQuestionQrCode()
        })

        this.videoSetDialog = false
        this.isShowVideoSet = false
      } catch (error) {
        console.log(error)
      }
    },

    async getVideoRecommendList() {
      try {
        this.videoRecommendList = await fetchRecommendVideoList({
          count: 4
        })
      } catch (error) {

      }
    },

    async getCommentList() {
      try {
        this.commentList = await fetchCommentList({
          video_code: this.detailInfo.video_code
        })
      } catch (error) {

      }
    },

    async addComment() { // 添加评论
      if (!this.commentVal && !this.scoreVal) {
        this.$message.error('请选择评分或输入评论内容')
        return
      }

      const params = {
        content: this.commentVal,
        type: 1,
        object_id: this.detailInfo.video_code
      }

      if (this.scoreVal) {
        params.score = this.scoreVal * 2
      }

      try {
        await addComment(params)

        this.$message.success('操作成功')

        this.commentVal = ''
        this.scoreVal = 0
        this.getCommentList()
      } catch (error) {
        console.log(error)
      }
    },

    initQrCode() {
      const { video_code, title } = this.detailInfo

      const loadData = {
        entrance: 'mInput',

        video_code,
        object_code: this.objectCode,

        title,

        token: getToken(),
        userName: getAccount(),
        mobile: getMobile(),
        avatar: getAva(),
        state: getState()
      }

      console.log(777777)
      console.log(loadData)

      new QRCode(document.getElementById("qrcode"), {
        text: `${window.location.origin}/#/land?loadData=${encodeURIComponent(JSON.stringify(loadData))}`
      })
    },

    initQuestionQrCode() {
      const loadData = {
        entrance: 'question',

        title: this.detailInfo.title,
        object_code: this.objectCode,

        token: getToken(),
        userName: getAccount(),
        mobile: getMobile(),
        avatar: getAva(),
        state: getState()
      }

      console.log(777777)
      console.log(loadData)

      new QRCode(document.getElementById("question-qrcode"), {
        text: `${window.location.origin}/#/land?loadData=${encodeURIComponent(JSON.stringify(loadData))}`
      })
    }
  },
  created() {
    this.getVideoRecommendList()

    if (this.contentId && this.videoCode) {
      this.getContentDetail()
    }
  }
}
</script>

<style lang="scss">
.content-video-detail-container {

  #qrcode {
    canvas {
      width: 100%;
    }
  }

  &.isMobile {
    .content-detail-box  {
      display: block;

      .content-text {
        .video {
          height: 255px !important;
        }
      }
    }
  }

  .content-detail {
    padding: 46px 0 124px;

    .content-detail-box {

      .left {
        flex: 0 0 70%;

        .comment-box {
          .comment-list {
            box-shadow: 0px 0px 10px 0px rgba(26, 104, 202, 0.1);
            border-radius: 10px;
            padding: 28px 34px;
            background-color: #fff;
            margin-top: 21px;

            .title {
              font-size: 16px;
              font-weight: normal;
              color: #0A1121;
              line-height: 24px;
              margin-bottom: 31px;
            }

            .item {
              padding-bottom: 14px;
              border-bottom: 1px solid #E6EAF0;
              margin-bottom: 29px;

              &:last-child {
                margin-bottom: 0;
                border-bottom: none;
              }

              .ava {
                width: 52px;
                height: 52px;
                overflow: hidden;
                border-radius: 50%;
                margin-right: 15px;
                // flex: 0 0 8.3%;
                flex-shrink: 0;
              }

              .right-content {
                // flex: 0 0 87%;
                flex-grow: 1;

                .name {
                  font-size: 14px;
                  color: #0A1121;
                  margin-right: 9px;
                }

                .time {
                  font-size: 12px;
                  color: #A8ADBA;
                }

                .content {
                  margin-top: 10px;
                  font-size: 14px;
                  font-weight: normal;
                  color: #596270;
                  line-height: 24px;
                }

              }
            }

          }

          .submit-comment {
            background: #FFFFFF;
            box-shadow: 0px 0px 10px 0px rgba(26, 104, 202, 0.1);
            border-radius: 10px;
            padding: 31px 37px;

            .title {
              font-size: 16px;
              font-weight: normal;
              color: #0A1121;
              line-height: 24px;
              margin-bottom: 31px;
            }

            .input-box {
              margin-bottom: 13px;
            }

            .ava {
              width: 52px;
              height: 52px;
              overflow: hidden;
              border-radius: 50%;
              margin-right: 15px;
              flex-shrink: 0;

            }

            .input {
              flex-grow: 1;

            }
          }
        }

        .content-text {
          // padding: 26px 0 0;
          margin-top: 26px;
          margin-bottom: 16px;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
          // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          position: relative;

          .video {
            width: 100%;
            height: 405px;
            // background: $primary;
            border-radius: 8px;
          }

          .warp-box {
            position: absolute;
            top: 0px;
            bottom: 0px;
            left: 0;
            right: 0;
            border-radius: 8px;
            background-color: rgba(255, 255, 255, 0.4);
            display: flex;
            justify-content: center;
            align-items: center;            
          }
        }

        .down-list {
          margin-bottom: 16px;
          .down-item {
            color: $primary;
            cursor: pointer;
            font-size: 14px;
          }
        }

        .bottom-link {
          margin-top: 33px;

          .flex {
            font-size: 14px;
            .text {
              color: #878A95;
            }

            .content-title {
              font-size: 14px;
              cursor: pointer;
              color: $primary;
            }
          }
        }
      }

      .right {
        flex: 0 0 25%;
        // background: $primary;

        .common-block {
          background: #FFFFFF;
          box-shadow: 0px 0px 10px 0px rgba(26, 104, 202, 0.1);
          border-radius: 10px;
          padding: 25px 18px;
          margin-bottom: 25px;

          .top {
            margin-bottom: 28px;
            .icon {
              &.news {
                background: url(~@/assets/recommend-news.png) no-repeat;
                background-size: 100% 100%;
                width: 32px;
                height: 26px;
                margin-right: 10px;
              }

              &.qrcode {
                color: $primary;
                font-size: 32px;
                margin-right: 10px;
              }
            }

            .title {
              font-size: 16px;

              font-weight: normal;
              color: #0A1121;
              line-height: 24px;
            }
          }

          .list {
            .item {
              margin-bottom: 28px;
              cursor: pointer;

              &:hover {
                .content {
                  color: $primary !important;
                }
              }

              &:last-child {
                margin-bottom: 0;
              }

              .list-left {
                // flex: 0 0 5%;
                flex-shrink: 0;
                margin-right: 10px;
                .icon {
                  margin-top: 6px;
                  width: 5px;
                  height: 10px;

                  background: url(~@/assets/sx-icon.png) no-repeat;
                  background-size: 100% 100%;
                }
              }

              .list-right {
                // flex: 0 0 90%;
                flex-grow: 1;
                .content {
                  font-size: 14px;
                  font-weight: normal;
                  color: #0A1121;
                  line-height: 20px;
                  margin-bottom: 17px;
                }

                .time {
                  font-size: 14px;
                  font-weight: 400;
                  color: #878A95;
                }
              }
            }
          }
        }
      }
    }
  }

}
</style>